// extracted by mini-css-extract-plugin
export default {"wrapper":"AllFilters_wrapper__tHsul"};